"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("src/utilities/styled/color"));
var map = {
    primary: 0,
    secondary: 1,
    nav: 2,
    linkPrimary: 3,
    linkSecondary: 4,
    linkTertiary: 5,
};
exports.default = (function (type, _a) {
    var _b = _a === void 0 ? {} : _a, hovered = _b.hovered;
    return function (_a) {
        var theme = _a.theme, color = _a.color, brand = _a.brand;
        if (color) {
            return (0, color_1.default)({ theme: theme, color: color });
        }
        var index = brand ? 0 : map[type];
        if (hovered) {
            return theme.palette.buttonColorHover[index];
        }
        return theme.palette.buttonColor[index];
    };
});
